// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.full_menu-list[data-v-463df8e6] {\n    padding: 0;\n    margin: 0;\n    list-style-type: none;\n}\n.list-item[data-v-463df8e6] {\n    margin: 5px 0;\n}\n.full_menu-list .list-item a[data-v-463df8e6] {\n    color: var(--grey-color);\n    font-size: 14px;\n    text-decoration: none;\n}\n.router-link-active[data-v-463df8e6] {\n    color: var(--green-color) !important;\n}\n", ""]);
// Exports
module.exports = exports;
